import { render } from "./SubmissionSuccess.vue?vue&type=template&id=d2a87e72"
import script from "./SubmissionSuccess.vue?vue&type=script&lang=js"
export * from "./SubmissionSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__